// App.js - Version améliorée
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";
import Signin from "./pages/Signin2";
import PrivateRoute from "./components/PrivateRoute";
import { Spinner } from "react-bootstrap";
import { initTaxes } from './utils/taxesHelper';
import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";

import "./assets/css/remixicon.css";
import "./scss/style.scss";
import ClientDetails from "./ventes/ClientDetails";
import DetailClient from "./ventes/DetailClient";
import Decaissement from "./pages/caisse/Decaissement";
import OperationsCaisse from "./pages/caisse/OperationsCaisse";
import DetailOperation from "./pages/caisse/DetailOperation";
import StatsCaisse from "./pages/caisse/StatsCaisse";
import Contrats from "./pages/contrats/Contrats";
import NouveauContrat from "./pages/contrats/NouveauContrat";
import AlertesContrats from "./pages/contrats/AlertesContrats";
import DetailContrat from "./pages/contrats/DetailContrat";
import AjouterEmploye from "./pages/rh/AjouterEmploye";
import Employes from "./pages/rh/Employes";
import DetailEmploye from "./pages/rh/DetailEmploye";

// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
     initTaxes();
    // Simuler un petit délai pour que tout soit chargé
    const timer = setTimeout(() => setInitialized(true), 100);
    return () => clearTimeout(timer);
  }, []);

 if (!initialized) {
  return (
    <>
      <div className="app-init-screen" style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }}>
        <div className="text-center">
          {/* Logo animé */}
          <div className="init-logo-wrapper mb-4">
            <div className="init-logo-ring">
              <div className="init-logo-ring-inner"></div>
            </div>
            <i className="ri-rocket-line init-rocket-icon"></i>
          </div>
          
          {/* Titre */}
          <h3 className="text-white fw-bold mb-2">GEOTECH</h3>
          <p className="text-white-50 mb-4">Système de gestion intégré</p>
          
          {/* Spinner élégant */}
          <div className="init-spinner-wrapper mb-4">
            <div className="spinner-border text-white" style={{ width: '2.5rem', height: '2.5rem' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
            <div className="spinner-border text-white-50 position-absolute top-0 start-0" style={{ width: '2.5rem', height: '2.5rem', animationDelay: '0.3s', opacity: 0.7 }}>
              <span className="visually-hidden">Chargement...</span>
            </div>
            <div className="spinner-border text-white-25 position-absolute top-0 start-0" style={{ width: '2.5rem', height: '2.5rem', animationDelay: '0.6s', opacity: 0.4 }}>
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
          
          {/* Texte de chargement */}
          <h6 className="text-white mb-2">Initialisation de l'application</h6>
          <p className="text-white-50 small mb-0">Veuillez patienter...</p>
          
          {/* Barre de progression */}
          <div className="mx-auto mt-4" style={{ width: '250px' }}>
            <div className="progress init-progress" style={{ height: '3px', borderRadius: '3px', background: 'rgba(255,255,255,0.2)' }}>
              <div 
                className="progress-bar init-progress-bar" 
                style={{ 
                  width: '100%', 
                  background: 'linear-gradient(90deg, #fff, rgba(255,255,255,0.5))',
                  animation: 'init-progress 1.5s ease-in-out infinite'
                }}
              />
            </div>
          </div>
          
          {/* Points de chargement */}
          <div className="init-dots mt-3">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
      
      <style>{`
        .app-init-screen {
          animation: fadeIn 0.5s ease-out;
        }
        
        .init-logo-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 0 auto;
        }
        
        .init-logo-ring {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(255,255,255,0.3), rgba(255,255,255,0.1));
          animation: pulse-ring 1.5s ease-in-out infinite;
        }
        
        .init-logo-ring-inner {
          position: absolute;
          top: 8px;
          left: 8px;
          right: 8px;
          bottom: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.1);
        }
        
        .init-rocket-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 38px;
          color: white;
          z-index: 2;
          animation: float 2s ease-in-out infinite;
        }
        
        .init-spinner-wrapper {
          position: relative;
          width: 2.5rem;
          height: 2.5rem;
          margin: 0 auto;
        }
        
        .init-progress-bar {
          animation: init-progress 1.5s ease-in-out infinite;
        }
        
        .init-dots {
          display: flex;
          gap: 8px;
          justify-content: center;
        }
        
        .init-dots .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          animation: dot-pulse 1.5s ease-in-out infinite;
        }
        
        .init-dots .dot:nth-child(1) { animation-delay: 0s; }
        .init-dots .dot:nth-child(2) { animation-delay: 0.2s; }
        .init-dots .dot:nth-child(3) { animation-delay: 0.4s; }
        .init-dots .dot:nth-child(4) { animation-delay: 0.6s; }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes pulse-ring {
          0% { transform: scale(0.9); opacity: 0.7; }
          50% { transform: scale(1.1); opacity: 0.3; }
          100% { transform: scale(0.9); opacity: 0.7; }
        }
        
        @keyframes float {
          0%, 100% { transform: translate(-50%, -50%) translateY(0); }
          50% { transform: translate(-50%, -50%) translateY(-10px); }
        }
        
        @keyframes init-progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        
        @keyframes dot-pulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.2); }
        }
        
        .text-white-50 { color: rgba(255,255,255,0.5); }
        .text-white-25 { color: rgba(255,255,255,0.25); }
      `}</style>
    </>
  );
}

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/pages/signin2" replace />} />
        <Route path="/login" element={<Navigate to="/pages/signin2" replace />} />
        <Route path="/pages/signin2" element={<Signin />} />

        {publicRoutes && publicRoutes.map((route, index) => (
          <Route
            path={route.path}
            element={route.element}
            key={`public-${index}`}
          />
        ))}

        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard/finance" replace />} />
          
          {protectedRoutes && protectedRoutes.map((route, index) => (
            <Route
              path={route.path}
              element={route.element}
              key={`protected-${index}`}
            />
          ))}

          <Route path="/caisse/operations" element={<OperationsCaisse />} />
          <Route path="/caisse/decaissement" element={<Decaissement />} />

          <Route path="/caisse/stats" element={<StatsCaisse />} />


<Route path="/rh/employes" element={<Employes />} />
<Route path="/rh/employesAjouter" element={<AjouterEmploye />} />
{/* <Route path="/rh/employes/:id" element={<DetailEmploye />} /> */}


          <Route path="/rh/contrats" element={<Contrats />} />
<Route path="/rh/contratsNouveau" element={<NouveauContrat />} />
<Route path="/rh/contratsAlertes" element={<AlertesContrats />} />
<Route path="/rh/contrats/:id" element={<DetailContrat />} />



<Route path="/rh/employes/:id" element={<DetailEmploye />} />
          <Route path="/ventes/clients/:id" element={<DetailClient />} />
          
          <Route path="/caisse/operations/:id" element={<DetailOperation />} />

        

        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}